const messages = {
  unnamed: '--без имени--',
  id: 'ID',
  all: '--Все--',
  not_used: '--Не используется--',
  account: 'Аккаунт',
  data: 'Данные',
  pieces: 'шт.',
  placeholder_hm: 'ЧЧ:ММ',
  placeholder_hms: 'ЧЧ:ММ:CC',
  amount: 'Сумма',
  balance: 'Баланс',
  bulk_id: 'ID рассылки',
  detail: 'Подробно',
  detail_info: 'Информация о сообщении',
  detail_incoming: 'Детальная статистика входящих',
  description: 'Описание',
  info: 'Информация',
  error: 'Ошибка',
  error_code: 'Код ошибки',
  error_description: 'Описание ошибки',
  emailAttachedFilesSizeLimit: 'Не удалось прикрепить файл {filename} - размер файлов аттачей превышает 25 мегабайт',
  group: 'Групповая статистика',
  group_by: 'Группировать по',
  group_by_optionally: 'Дополнительно группировать по',
  group_incoming: 'Групповая статистика входящих',
  message: 'Сообщение',
  message_type: 'Тип сообщения',
  push_type: 'Тип уведомления',
  messageLength: 'Длина сообщения',
  message_parts: 'Количество частей',
  message_category: 'Категория сообщения',
  name: 'Наименование',
  originators: 'Адреса отправителей',
  overdraft: 'Овердрафт',
  partner: 'Клиент',
  partners: 'Клиенты',
  partner_user: 'Пользователь',
  partner_price: 'Цена',
  price: 'Цена',
  priority: 'Приоритет',
  provider_price: 'Цена поставщика услуг',
  proceed: 'Продолжить',
  preview: "Предпросмотр",
  pc_version: "Версия для ПК",
  mobile_version: "Версия для смартфона",
  display: "Отобразить",
  choose_payment_system: 'Выберите платежную систему',
  topup_balance: 'Пополнение баланса',
  quantity: 'Количество',
  rule: 'Правило',
  service_provider: 'Поставщик услуг',
  service_providers: 'Поставщики услуг',
  source: 'Источник',
  status: 'Статус',
  template: 'Шаблон',
  templates: 'Шаблоны',
  template_id: 'ID шаблона',
  templates_new: 'Создание шаблона',
  templates_edit: 'Редактирование шаблона',
  custom_parameters: 'Пользовательские параметры',
  custom_parameter_name: 'Наименование параметра',
  custom_parameter_value: 'Значение',
  timeout: 'Таймаут',
  transport: 'Канал',
  file: 'Файл',
  variables: 'Переменные',
  firstname: 'Имя',
  surname: 'Фамилия',
  middlename: 'Отчество',
  field1: 'Поле 1',
  field2: 'Поле 2',
  field3: 'Поле 3',
  field4: 'Поле 4',
  field5: 'Поле 5',
  field6: 'Поле 6',
  email: 'Почта',
  password: 'Пароль',
  confirm_password: 'Подтвердите пароль',
  password_changed: 'Пароль успешно изменен',
  timeZone: 'Часовой пояс',
  show_messages_text: 'Отображать тексты сообщений',
  is_check_pass: 'Сменить пароль при следующей авторизации',
  show_finance_info: 'Показывать финансовую информацию',
  pages: 'Страницы',
  role: 'Роль',
  role_use: 'Использовать роль',
  role_settings: 'Настройки роли',
  without_role: '--Без роли--',
  msisdn: 'Телефон',
  company: 'Компания',
  filters: 'Фильтры',
  filters_additional: 'Дополнительные фильтры',
  filter_hide: 'скрыть фильтр',
  filters_clear: 'Очистить фильтры',
  filter: 'Фильтр',
  group_settings: 'Настройки группы',
  search: 'Поиск',
  create: 'Создать',
  add: 'Добавить',
  save: 'Сохранить',
  update: 'Обновить',
  enter_name: 'Введите наименование',
  clone: 'Клонировать',
  clone_template: 'Клонирование шаблона',
  clone_description: 'После нажатия на "Продолжить" будет открыта страница редактирования нового шаблона',
  back_to_list: 'Назад к списку',
  template_save: 'Сохранить как новый шаблон',
  template_update: 'Обновить текущий шаблон',
  filter_save: 'Сохранить как новый фильтр',
  filter_update: 'Обновить текущий фильтр',
  remove: 'Удалить',
  apply: 'Применить',
  export: 'Экспорт',
  import: 'Импорт',
  download: 'Скачать',
  upload: 'Загрузить',
  cancel: 'Отменить',
  confirm: 'Ок',
  logout: 'Выход',
  resend: 'Переотправить',
  back: 'Назад',
  display_charts: 'Отображать графики',
  attach: 'Прикрепить',
  next: 'Далее',
  previous: 'Назад',
  tableEmpty: 'Задайте параметры поиска <br> для получения выдачи',
  browserNotSupport: 'Данный браузер не поддерживается',
  audio_not_supported: 'Ваш браузер не поддерживает проигрывание аудио',
  forbidden: 'Запрещено',
  absent: 'Отсутствует',
  base_settings: 'Основные настройки',
  additional_settings: 'Дополнительные настройки',
  cascading: 'Каскадирование',
  scheduler: 'Планировщик',
  smpp_settings: 'Настройки SMPP аккаунта',
  processing_logic_settings : 'Настройки логики обработки',
  http_settings: 'Настройки HTTP аккаунта',
  allowed_operators: 'Разрешенные поставщики услуг',
  newTemplate: 'Новый шаблон',
  button_link: 'Ссылка для перехода',
  active: 'Активность',
  lifetime: 'Срок жизни сообщения (с)',
  blacklist: 'Черный список',
  max_throughput: 'Максимальная пропускная способность',
  statistic: 'Отображать текст в статистике',
  use_cascading: 'Использовать каскадирование',
  channel: 'Канал доставки',
  tooltip_timeout: 'Время в формате ЧЧ:ММ:СС, через которое будет осуществлена отправка по альтернативному каналу',
  tooltip_addressbookcontact_duplicate: 'Полное совпадение по MSISDN и Email с другим контактом группы считается дубликатом. Сохранить такой контакт невозможно.',
  tooltip_blacklistcontact_duplicate: 'Полное совпадение по MSISDN и Email с другим контактом чёрного списка считается дубликатом. Сохранить такой контакт невозможно.',
  tooltip_multichannelPositiveSending: 'Активатор отправки по альтернативному каналу при позитивных статусах сообщений. \
  <p>• Если переключатель активирован, то отправка по альтернативному каналу будет осуществлена, независимо от того было ли доставлено исходное сообщение. </p>\
  <p>• Если переключатель деактивирован, то отправка по альтернативному каналу будет выполнена только при недоставке исходного сообщения.</p>',
  multichannelPositiveSending: 'Каскадирование доставленных сообщений',
  allowedDays: 'Дни для отправки',
  send_evenly: 'Равномерно распределять рассылку',
  translit: 'Транслитерация',
  char_entered: 'Введено символов',
  author: 'Автор',
  editDate: 'Дата редактирования',
  comment: 'Комментарий',
  title: 'Заголовок',
  content: 'Контент',
  choose_application: 'Выберите приложение',
  startDate: 'Дата с',
  endDate: 'Дата по',
  date_from: 'Дата с',
  date_to: 'Дата по',
  sent_date_from: 'Дата отправки с',
  sent_date_to: 'Дата отправки по',
  deliver_date_from: 'Дата доставки с',
  deliver_date_to: 'Дата доставки по',
  defer_date: 'Дата отложенной отправки',
  sent_date: 'Дата отправки',
  read_date: 'Дата прочтения',
  account_name: 'Наименование аккаунта',
  account_login: 'Логин аккаунта',
  protocol: 'Протокол',
  report_type: 'Тип отчета',
  push_statuses: 'Автоматическое получение статусов доставки',
  status_report: 'Сообщать о статусах',
  processing_rule: 'Правило обработки',
  immediate_response_needed: 'Сразу возвращать submit_sm_resp',
  additional_processing: 'Дополнительная обработка',
  for_all: 'Всех',
  final: 'Финальных',
  broker_api_doc: 'Документация по broker-api',
  originator: 'Отправитель',
  originator_address: 'Адрес отправителя',
  originator_operator: 'Оператор',
  originator_country: 'Страна',
  recipient: 'Получатель',
  recipient_region: 'Регион',
  recipient_country: 'Страна',
  operator: 'Оператор',
  service_provider: 'Поставщик услуг',
  mcc: 'MCC',
  mnc: 'MNC',
  broker_account_login: 'Аккаунт',
  otp_code_variable: 'Имя переменной OTP-кода',
  partner_user_login: 'Логин пользователя ЛК',
  smpp_message_id: 'SMPP ID',
  provider_message_id: 'Операторский ID',
  provider_protocol: 'Операторский протокол',
  module: 'SMPP-коннект',
  external_id: 'ID во внешней системе',
  postponed_date: 'Дата отложенной отправки',
  send_date: 'Дата отправки',
  delivery_date: 'Дата доставки',
  source_type: 'Тип источника',
  parent_message_id: 'ID родительского сообщения',
  parent_message_channel: 'Канал родительского сообщения',
  connection_type: 'Тип подключения',
  ext_id1: 'Ext_ID 1',
  ext_id2: 'Ext_ID 2',
  ext_id3: 'Ext_ID 3',
  ext_id4: 'Ext_ID 4',
  ext_id5: 'Ext_ID 5',
  ext_id6: 'Ext_ID 6',
  service_number: 'Номер',
  connectionType: 'Тип подключения',
  country: 'Страна',
  msgParts: 'Частей',
  createDate: 'Дата создания',
  create_date: 'Дата создания',
  deliveryDate: 'Дата доставки',
  readDate: 'Дата прочтения',
  duration: 'Длительность',
  application: 'Приложение',
  platform: 'Операционная система',
  os: 'Операционная система',
  os_version: 'Версия ОС',
  sdk_version: 'Версия SDK',
  mapp_version: 'Версия МП',
  deliveryType: 'Способ отправки',
  by_number: 'по номерам',
  by_filter: 'по фильтру',
  client_filter: 'Фильтр по клиентам',
  device_filter: 'Фильтр по устройствам',
  finishDate: 'Дата завершения',
  finish_date: 'Дата завершения',
  sender: 'Отправитель',
  charged: 'Списано',
  subject: 'Тема письма',
  message_text: 'Текст письма',
  show_message_text: 'Показать текст письма',
  message_text_empty: 'Текст письма не задан',
  call_events: 'События звонка',
  show_call_events: 'Показать события звонка',
  mnService: 'Сервис Mail Notify',
  mnTemplate: 'Шаблон Mail Notify',
  mnRoutes: 'Список соц.сетей для отправки',
  vkMessage: 'Текст сообщения для VK',
  okMessage: 'Текст сообщения для OK',
  empty: 'Пусто',
  date: 'Дата',
  transmitted: 'Отправлено',
  transmitted_parts: 'Отправлено (частей)',
  sent: 'Отправлено',
  delivered: 'Доставлено',
  delivered_parts: 'Доставлено (частей)',
  not_delivered: 'Не доставлено',
  not_delivered_parts: 'Не доставлено (частей)',
  expired: 'Просрочено',
  expired_parts: 'Просрочено (частей)',
  failed: 'Ошибка',
  failed_parts: 'Ошибка (частей)',
  error: 'Ошибка',
  read: 'Прочитано',
  rejected: 'Отклонено',
  rejected_parts: 'Отклонено (частей)',
  deferred: 'Отложено',
  deferred_parts: 'Отложено (частей)',
  buffered: 'buffered',
  not_answered: 'Не отвечено',
  finished: 'Завершено',
  duration: 'Длительность',
  charged: 'Списано',
  CallsCount: 'Всего',
  All: 'Всего',
  total: 'Всего',
  total_parts: 'Всего (частей)',
  page_size: 'Размер страницы',
  page_number: 'Номер страницы',
  order_by: 'Сортировать по',
  order_direction: 'Направление сортировки',
  message_direction: 'Направление сообщения',
  message_id: 'ID сообщения',
  checkDuplicatesPolicy: 'Параметры проверки на уникальность',
  groupId: 'Адресная книга',
  blackListId: 'Чёрный список',
  number: 'Количество',
  checkContacts: 'Проверить контакты',
  contactsImported: 'Количество импортированных контактов',
  contactsCopied: 'Количество скопированных контактов',
  contactsMoved: 'Количество перемещённых контактов',
  fromGroupId: 'Адресная книга - источник',
  toGroupId: 'Адресная книга - приёмник',
  fromBlackListId: 'Чёрный список - источник',
  toBlackListId: 'Чёрный список - приёмник',
  senderId: 'Отправитель',
  templateId: 'ID шаблона',
  messageTypeId: 'Тип сообщения',
  multichannelId: 'Канал',
  multichannelTemplateId: 'Шаблон',
  startDatetime: 'Дата отправки',
  endDatetime: 'Дата окончания',
  timeBegin: 'Время отправки',
  timeEnd: 'Время окончания',
  applicationId: 'Приложение',
  from: 'От кого',
  attachedFiles: 'Файлы вложений',
  buttonLink: 'Ссылка кнопки',
  buttonName: 'Название кнопки',
  image: 'Изображение',
  image_link: 'Ссылка на изображение',
  link: 'Ссылка',
  upload_file_description: 'Перетащите файл на страницу или нажмите кнопку загрузить',
  mnServiceId: 'Сервис Mail Notify',
  mnTemplateId: 'Шаблон Mail Notify',
  routes: 'Список соц.сетей для отправки',
  payloadType: 'Тип контента',
  maxRepeatCount: 'Максимальное количество повторных прослушиваний',
  repeatDtmf: 'Клавиша для повторного прослушивания',
  callRedirectDtmf: 'По клавише',
  redirectBeep: 'После звукового сообщения',
  redirectNumber: 'Номер',
  sendSmsEnd: 'После завершения звонка',
  sendSmsDtmf: 'По клавише',
  smsTemplateId: 'Шаблон текста SMS',
  dialing: 'Максимальное время дозвона (с)',
  maxRetryCount: 'Максимальное количество повторных звонков',
  retryInterval: 'Интервал повторной отправки звонка',
  totalRecipients: 'Количество контактов',
  duplicatesCount: 'Количество контактов-дубликатов',
  cascadingStatusTooltip: 'Статус сообщения, при отсутствии которого активируется функционал каскадирования.',
  cancelCascading: "Отмена каскадирования по статусам",
  tooltipCancelCascading: "При включении отправка сообщения по альтернативному каналу будет отменена, если по сообщению был получен один из статусов, отмеченных ниже в поле «Статусы отмены»",
  cancellationStatus: "Статусы отмены",
  masking: "Маскирование",
  maskingMethod: "Способ маскирования",
  doNotMask: "Не маскировать",
  maskAllText: "Весь текст",
  maskVariablesOnly: "Только переменные",
  mask: "Маскировать",
  maskedVariablesFromText: "Маскируемые переменные из текста",
  defaultMaskedVariables: "По умолчанию маскируются следующие переменные: {variables}.",
  additionalInfo: 'Дополнительная информация',
  custom_data: 'Дополнительные данные',
  applications: 'Приложения',
  app_groups: 'Группы приложений',
  app_by_date: 'Выбор по дате создания',
  app_by_date_tooltip: 'Выбор приложения по дате создания. Если выбрано Все, то отправка уведомления будет осуществлена во все\n' +
      '                  выбранные приложения. Если выбрано Последнее созданное, то отправка уведомления будет осуществлена\n' +
      '                  только в последнее созданное приложение. В выборке участвуют только те приложения, на которые подписан\n' +
      '                  получатель.',
  group_selection_rule: 'Правило выбора группы',
  group_selection_rule_tooltip: 'Правило выбора группы приложений. Если выбрано Все, то осуществляется выбор всех групп для отправки.\n' +
      '                  Если выбрано По приоритету, то осуществляется выбор самой приоритетной группы для отправки. В выборке\n' +
      '                  участвуют только те группы, в которых есть хотя бы одно приложение, на которое подписан получатель.',
  app_selection_rule: 'Правило выбора приложения',
  app_selection_rule_tooltip: 'Правило выбора приложения. Если выбрано Все, то осуществляется выбор всех приложений группы для\n' +
      '                  отправки. Если выбрано По приоритету, то осуществляется выбор самого приоритетного приложения группы\n' +
      '                  для отправки. Если выбрано Последнее созданное, то осуществляется выбор последнего созданного\n' +
      '                  приложения группы для отправки. В выборке участвуют только те приложения, на которые подписан\n' +
      '                  получатель.',
  sublist_settings: 'Настройки подписок',
  sublist_app_by_date_tooltip: 'Выбор подписки по дате создания. Если выбрано Все, то отправка уведомления будет осуществлена на все подписки приложений. Если выбрано Последняя созданная, то отправка уведомления будет осуществлена только на последнюю созданную подписку приложений.',
  selected_application: 'Выбор приложения',
  selected_subscription: 'Выбор подписки',
  selected_application_group: 'Выбор группы приложений',
  specialUnsubscribeRule: 'Правило специализированной отписки',
  unsubscribeLinksRegex: 'Регулярное выражение поиска ссылок отписки',
  unsubscribeRule: 'Правило отписки по ссылке из тела письма',
  subscribeLinksRegex: 'Регулярное выражение поиска ссылок подписки',
  subscribeRule: 'Правило подписки по ссылке из тела письма',
  proxyLinksRegex: 'Регулярное выражение поиска ссылок для проксирования',
  eventsCount: 'Количество событий',
  eventDate: 'Дата события',
  eventType: 'Тип события',
  openings: 'Открытий',
  subscribings: 'Подписок',
  unsubscribings: 'Отписок',
  following_links: 'Переходов по ссылкам',
  additional_params: 'Дополнительные параметры шаблона',
  key: 'Ключ',
  value: 'Значение',
  allow_merchant: 'Разрешить использование мерчантов',
  additional_parameters: 'Дополнительные параметры',
  parameter: 'Параметр',
  add_parameter: 'Добавить параметр',
  push_link: 'Ссылка по нажатию на уведомление',
  controls: 'Элементы управления',
  button_settings: 'Настройки кнопки',
  button_text: 'Текст кнопки',
  button_id: 'Идентификатор',
  button_action: 'Назначение',
  button_value: 'Обрабатываемое значение',
  add_button: 'Добавить кнопку',
  banner_link: 'Ссылка на банер',
  logo_link: 'Ссылка на логотип',
  subtitle: 'Подзаголовок',
  image: 'Изображение',
  link: 'Ссылка',
  banner: 'Баннер',
  logo: 'Логотип',
  group_name: 'Наименование группы',
  group_id: 'Идентификатор группы',
  sdk: 'SDK',
  mobile_app: 'Мобильное приложение',
  native_push_settings: 'Настройки для Native Push',
  android_settings: 'Настройки Android',
  ios_settings: 'Настройки iOS',
  web_settings: 'Настройки Web',
  push_view_type: 'Средство отображения уведомления',
  icon: 'Значок на иконке',
  not_set: 'Не устанавливать',
  set_in: 'Установить в',
  zoom_in: 'Увеличить на',
  param_name: 'Название параметра',
  param_value: 'Значение параметра',

  auth: {
    title: 'Личный кабинет',
    description: 'Авторизация',
    changing_title: 'Согласно политике безопасности Вам нужно сменить пароль',
    button: 'Войти',
    back: 'На страницу авторизации',
    change_password: 'Сменить пароль',
    language: 'Язык интерфейса',
    email: 'Электронная почта',
    username: 'Электронная почта / Логин AD',
    login: 'Имя пользователя',
    password: 'Пароль',
    new_password: 'Новый пароль',
    confirm_new_password: 'Подтвердите новый пароль',
    authorization: 'Авторизация',
    registration: 'Регистрация',
    captcha: 'Введите код с картинки',
    code: 'Код из email-сообщения',
    forgot_password: 'Забыли пароль',
    send_link: 'Отправить ссылку',
    reset_password: 'Сброс пароля',
    reset_password_description: 'Укажите ваш email для отправки ссылки для сброса пароля',
    reset_password_success: 'На электронную почту пользователя личного кабинета отправлена ссылка для сброса пароля',
  },

  errors: {
    internal: 'Внутренняя ошибка сервера.',
    request: 'Отсутствует обязательное поле/Неверный формат запроса',
    violation: 'Запись с идентичным(и) параметром(aми) уже существует',
    not_found: 'Запрашиваемые данные не найдены',
    invalid_credentials: 'Невозможно авторизоваться.<br>Неправильный логин/пароль.',
    invalid_start_end_time: 'Неправильная дата начала/завершения',
    present_dependence: 'Есть зависимости',
    user_locked: 'Невозможно авторизоваться.<br>Ваш аккаунт заблокирован.',
    unauthorized: 'Ошибка доступа',
    invalid_email_address: 'Некорректный email адрес',
    invalid_email_provider: 'Неразрешенный адрес email провайдера',
    invalid_file_name: 'Невозможно загрузить файл.<br>Некорректное наименование файла.',
    invalid_file_extension: 'Невозможно загрузить файл.<br>Неразрешенное расширение файла.',
    invalid_file_size: 'Невозможно загрузить файл.<br>Размер файла должен быть менее 20 мегабайт.',
    invalid_call_sender: 'Наименование Call отправителя должно быть не более 15 цифр',
    invalid_sms_sender: 'Наименование SMS отправителя не должно содержать запрещенные символы',
    not_active_user: 'Данный пользователь отключен',
    not_active_client: 'Данный клиент отключен',
    draft_exists: 'Невозможно сохранить черновик.<br>Черновик уже существует для данного шаблона.',
    passwords_not_equals: 'Невозможно сохранить данные профиля.<br>Пароли не совпадают.',
    password_already_used: 'Невозможно сохранить данные профиля.<br>Данный пароль уже использовался, выберите другой пароль.',
    file_parse_error: 'Невозможно загрузить файл.<br>Ошибка синтаксического анализа файла: несоответствие полей.',
    password_difference_symbols: 'Невозможно сменить пароль.<br>Новый пароль должен отличаться от предыдущего не менее чем на',
    password_length: 'Невозможно сменить пароль.<br>Новый пароль должен иметь длину не менее',
    user_temporary_locked: 'Невозможно авторизоваться.<br>Ваша учётная запись заблокирована из-за многократного неверного ввода логина/пароля.',
    user_locked_by_system: 'Невозможно авторизоваться.<br>Ваша учётная запись заблокирована, т.к. Вы не входили в систему более {0}.',
    ad_connection_error: 'Невозможно авторизоваться.<br>Не заданы настройки подключения Active Directory.',
    ad_login_exist: 'Невозможно авторизоваться.<br>Пользователь с таким логином уже есть в Системе.',
    no_data_to_export: 'Невозможно выполнить экспорт.<br>Нет данных для экспорта.',
    no_data_to_show: 'Нет данных для отображения',
    no_data_found: 'Запрашиваемые данные не найдены',
    addressbookcontact_check_failed: 'Невозможно сохранить контакт. Контакт не прошел проверки.',
    blacklistcontact_duplicate: 'Невозможно сохранить контакт. Контакт с такими данными уже существует в этом чёрном листе.',
    loop_in_cascading_chain: 'Невозможно создать рассылку. Возможно зацикливание каскадной отправки в шаблоне с идентификатором {templateID} канала {transport}.',
    loop_in_cascading_chain_template: 'Невозможно сохранить шаблон. Возможно зацикливание каскадной отправки в шаблоне с идентификатором {templateID} канала {transport}.',
    active_directory_server_unavailable: 'Невозможно авторизоваться. Сервер Active Directory недоступен',
    system_setting_value_is_not_set: 'Невозможно выполнить запрос. Не задана необходимая системная настройка',
    file_is_too_long: 'Невозможно импортировать файл. В импортируемом файле слишком много записей',
    duplicate_item_name: 'Данное наименование уже используется. Введите уникальное наименование',
    unable_data: 'Невозможно получить данные. Не заданы обязательные параметры: ',
    invalid_date_format: 'Неверный формат даты',
    invalid_date_interval: 'Невозможно получить данные. Некорректный интервал дат',
    forbidden: 'Невозможно получить данные. Доступ к странице не разрешён',
    transport_not_allowed: 'Невозможно получить данные. Канал не разрешён',
    server_unavailable: 'Невозможно выполнить запрос. Сервер приложений недоступен',
    incorrect_confirm_code: 'Неверный код подтверждения email',
    registration_error: 'Ошибка регистрации',
    captcha_failed: 'Не удалось провести проверку captcha',
    no_partner_user_found: 'Пользователя личного кабинета с такой электронной почтой нет в системе',
    change_password_limit: 'Превышено количество попыток смены пароля в течении заданного времени',
    change_password_link_expired: 'Превышено время ожидания сброса пароля по этой ссылке',
    change_password_attempts_exceeded: 'Превышено количество попыток смены пароля в течении заданного времени',
    captcha_verification_error: 'Неверный код captcha',
    operation_locked: 'Действие над сущностью не доступно, так как она участвует в другой операции',
    no_contacts: 'В группе контактов нет контактов для проверки',
    contact_group_in_use: 'Невозможно создать рассылку, выбранная группа контактов сейчас используется',
    mn_service_unavailable: 'Указанный сервис MN недоступен для клиента',
    moderation_template_no_diff: 'Нет отличий от исходного шаблона',
    insufficient_permissions: 'Недостаточно прав на выполнении действия',
    viber_custom_content_validation: "Одно из полей 'Сообщение', 'Изображение', 'Название кнопки', 'Ссылка кнопки', 'Файл' должно быть заполнено",
    viber_button_requires_link_or_file: "Если заполнено поле 'Название кнопки', то одно из полей 'Ссылка кнопки' или 'Файл' также должно быть заполнено"
  },

  dialog: {
    confirm: 'Сохранить изменения?',
    delete: 'Вы действительно хотите удалить запись?',
    error: 'Обнаружена ошибка',
    warning: 'ВНИМАНИЕ!',
    success: 'Операция успешно выполнена',
    export: 'Отчет успешно экспортирован',
    resend: 'Сообщение будет переотправлено',
    yes: 'Да',
    no: 'Нет',
    not_selected_transport: 'Должен быть выбран хотя бы один канал',
    delete_all_default_category: 'При назначении категории категорией по умолчанию все связанные с ней регулярные выражения для данного канала будут удалены. Вы, действительно, хотите продолжить?',
    delete_all_tarifzone: 'Будут удалены все связанные регулярные выражения и настройки тарифных зон'
  },

  pages: {
    dashboard: 'Стартовая страница',

    user: 'Профиль',
    user_profile: 'Личные данные',

    finances: 'Управление финансами',
    balances: 'История пополнений',

    distribution: 'Рассылки',
    distribution_list: 'Статусы рассылок',
    distribution_sms_new: 'Создание SMS-рассылки',
    distribution_call_new: 'Создание Call-рассылки',
    distribution_email_new: 'Создание Email-рассылки',
    distribution_push_new: 'Создание Push-рассылки',
    distribution_viber_new: 'Создание Viber-рассылки',
    distribution_whatsapp_new: 'Создание WhatsApp-рассылки',
    distribution_custom_new: 'Создание Custom-рассылки',
    distribution_mail_notify_new: 'Создание Mail Notify рассылки',
    telegram_otp_send: 'Отправка Telegram OTP',

    distribution_template: 'Шаблоны',
    distribution_template_sms: 'Шаблоны SMS',
    distribution_template_sms_new: 'Создание шаблона SMS рассылки',
    distribution_template_sms_edit: 'Редактирование шаблона SMS рассылки',
    distribution_template_call: 'Шаблоны Call',
    distribution_template_call_new: 'Создание шаблона Call рассылки',
    distribution_template_call_edit: 'Редактирование шаблона Call рассылки',
    distribution_template_call_sound: 'Файлы',
    distribution_template_email: 'Шаблоны Email',
    distribution_template_email_new: 'Создание шаблона Email рассылки',
    distribution_template_email_edit: 'Редактирование шаблона Email рассылки',
    distribution_template_push: 'Шаблоны Push',
    distribution_template_push_new: 'Создание шаблона Push рассылки',
    distribution_template_push_edit: 'Редактирование шаблона Push рассылки',
    distribution_template_viber: 'Шаблоны Viber',
    distribution_template_viber_new: 'Создание шаблона Viber рассылки',
    distribution_template_viber_edit: 'Редактирование шаблона Viber рассылки',
    distribution_template_whatsapp: 'Шаблоны WhatsApp',
    distribution_template_whatsapp_new: 'Создание шаблона WhatsApp рассылки',
    distribution_template_whatsapp_edit: 'Редактирование шаблона WhatsApp рассылки',
    distribution_template_telegram_otp: 'Шаблоны Telegram OTP',
    distribution_template_telegram_otp_new: 'Создание шаблона Telegram OTP рассылки',
    distribution_template_telegram_otp_edit: 'Редактирование шаблона Telegram OTP рассылки',
    distribution_template_custom: 'Шаблоны Custom',
    distribution_template_custom_new: 'Создание шаблона Custom рассылки',
    distribution_template_custom_edit: 'Редактирование шаблона Custom рассылки',
    distribution_template_mail_notify: 'Шаблоны Mail Notify',
    distribution_template_mail_notify_new: 'Создание шаблона Mail Notify рассылки',
    distribution_template_mail_notify_edit: 'Редактирование шаблона Mail Notify рассылки',

    accounts:'Аккаунты',
    accounts_new:'Создание аккаунта',
    accounts_edit:'Редактирование аккаунта',

    sender: 'Адреса отправителей',
    sender_new: 'Создание адреса отправителя',

    contacts: 'Контакты',
    address_book_group: 'Группы контактов',
    address_book_group_new: 'Создание группы контактов',
    address_book_group_edit: 'Редактирование группы контактов',
    address_book_group_contact: 'Контакты группы',
    address_book_group_contact_new: 'Создание контакта группы',
    address_book_group_contact_edit: 'Редактирование контакта группы',
    black_list_group: 'Черные списки',
    black_list_group_new: 'Создание черного списка',
    black_list_group_edit: 'Редактирование черного списка',
    black_list_group_contact: 'Контакты черного списка',
    black_list_group_contact_new: 'Создание контакта черного списка',
    black_list_group_contact_edit: 'Редактирование контакта черного списка',

    report_detailed: 'Детальная статистика',
    report_detailed_sms: 'Детальный отчет SMS',
    report_detailed_sms_info: 'Информация о сообщении',
    report_detailed_call: 'Детальный отчет Call',
    report_detailed_call_info: 'Информация о сообщении',
    report_detailed_email: 'Детальный отчет Email',
    report_detailed_email_info: 'Информация о сообщении',
    report_detailed_email_events_info: 'Информация о событии',
    report_detailed_push: 'Детальный отчет Push',
    report_detailed_push_info: 'Информация о сообщении',
    report_detailed_viber: 'Детальный отчет Viber',
    report_detailed_viber_info: 'Информация о сообщении',
    report_detailed_whatsapp: 'Детальный отчет WhatsApp',
    report_detailed_whatsapp_info: 'Информация о сообщении',
    report_detailed_telegram_otp: 'Детальный отчет Telegram OTP',
    report_detailed_telegram_otp_info: 'Информация о сообщении',
    report_detailed_custom: 'Детальный отчет Custom',
    report_detailed_custom_info: 'Информация о сообщении',
    report_detailed_mail_notify: 'Детальный отчет Mail Notify',
    report_detailed_mail_notify_info: 'Информация о сообщении',

    report_group: 'Групповая статистика',
    report_group_sms: 'Групповой отчет SMS',
    report_group_call: 'Групповой отчет Call',
    report_group_email: 'Групповой отчет Email',
    report_group_email_events: 'Групповой отчет событий Email',
    report_group_push: 'Групповой отчет Push',
    report_group_viber: 'Групповой отчет Viber',
    report_group_whatsapp: 'Групповой отчет WhatsApp',
    report_group_telegram_otp: 'Групповой отчет Telegram OTP',
    report_group_custom: 'Групповой отчет Custom',
    report_group_mail_notify: 'Групповой отчет Mail Notify',
    report_group_summary: 'Общий групповой отчет',

    report_export: 'Отчеты',
  },

  dashboard: {
    distributions: 'Рассылки',
    IN_PROGRESS: 'Запущено',
    STOPPED: 'Остановлено',
    PAYMENT_WAITING: 'Ожидают оплаты',
    ON_MODERATION: 'Ожидают модерации',
    FINISHED: 'Завершено',
    templates: 'Шаблоны',
    addressBooks: 'Группы контактов',
    addressBooks_count: 'Всего групп',
    addressBooks_contacts: 'Всего контактов',
    blacklists: 'Черные списки',
    blacklists_count: 'Всего списков',
    blacklists_contacts: 'Всего контактов',
    sended: 'Отправлено',
    today: 'Сегодня',
    yesterday: 'Вчера',
    month: 'За месяц',
    chart_title: 'Распределение трафика за последний месяц',
  },

  template: {
    statuses: {
      Active: 'Активен',
      NotActive: 'Неактивен',
      ForModeration: 'Ожидает модерации',
      OnModeration: 'На модерации',
      ForEdit: 'На редактировании',
      Denied: 'Отклонен',
      Approved: 'Разрешен',
    },
    draft: {
      has: 'У шаблона имеется черновик',
      no: 'Редактирование невозможно',
      goto: 'Перейти в черновик?',
      create: 'Создать черновик?',
      edit_forbidden: 'Редактирование невозможно',
      replace: 'Удалить текущий черновик и создать новый?',
    },
    gotoOriginal: 'Перейти в основной шаблон?',
    moderate: 'Отправить на модерацию',
    moderationDescription: 'Если Вы хотите изменить наименование шаблона, укажите наименование, отличное от текущего. Указанное наименование заменит текущее после прохождения модерации',
    email: {
      message: 'Текст письма',
      subject: 'Тема письма',
      email_from: 'От кого',
      attaches: 'Файлы вложений',
    },
    viber: {
      pic_link: 'Ссылка на изображение',
      button_name: 'Наименование кнопки',
      button_link: 'Ссылка кнопки',
    },
    call: {
      payloadType: 'Тип контента',
      repeat_flag: 'Прослушать сообщение повторно',
      maxRepeatCount: 'Максимальное количество повторных прослушиваний',
      repeatDtmf: 'Клавиша для повторного прослушивания',
      redirect_flag: 'Переадресация звонка',
      callRedirectDtmf: 'По клавише',
      redirectBeep: 'После звукового сообщения',
      redirectNumber: 'Номер',
      sms_flag: 'Отправлять SMS получателю',
      sendSmsEnd: 'После завершения звонка',
      sendSmsDtmf: 'По клавише',
      smsTemplateId: 'Шаблон текста SMS',
      dialing: 'Максимальное время дозвона (с)',
      retry_flag: 'Звонить повторно',
      maxRetryCount: 'Максимальное количество повторных звонков',
      retryInterval: 'Интервал повторной отправки звонка',
      file: 'Файл',
      ivrmenu: 'IVR-Меню',
      ttl: 'Срок жизни звонка (с)',
    },
    call_types: {
      ivrmenu: 'IVR-меню',
      text: 'Текст',
      file: 'Файл'
    },
    call_sound: {
      add_button: 'Добавить файл',
      fileId: 'ID',
      name: 'Наименование',
      patch: 'Ссылка',
      exist: 'Файл с таким наименованием уже загружен',
    }
  },

  contacts: {
    description: 'Выберите файл в формате txt, csv, xls, xlsx. Файлы в формате txt и csv должны иметь кодировку UTF8. Порядок полей для автоматического импорта: ',
    messages: {
      requiredMissing: 'Невозможно импортировать файл: обязательно должен быть установлен тип "MSISDN" или "Email"',
      fieldTypeDuplicates: 'Дублирующиеся типы полей',
      importCount: 'Контактов загружено: ',
      msisdnDuplicates: 'Дублирующихся номеров телефонов: ',
      failedMsisdns: 'Некорректных номеров телефонов: ',
      emailDuplicates: 'Дублирующихся адресов e-mail: ',
      failedEmails: 'Некорректных адресов e-mail: '
    },
    report: {
      verifiedContacts: 'Контактов прошедших проверку',
      out: 'из',
      found: 'Среди заблокированных записей, обнаружено',
      duplicates_count: 'Полностью дублирующихся контактов',
      msisdn_and_email_duplicates_count: 'Контактов с дублирующейся парой номера телефона и mail-адреса',
      incorrect_msisdn_count: 'Номеров телефонов с некорректным синтаксисом',
      msisdn_duplicates_count: 'Дублирующихся номеров телефонов',
      incorrect_addresses_count: 'Email-адресов с некорректным синтаксисом',
      email_duplicates_count: 'Дублирующихся Email-адресов',
      disposable_addresses_count: 'Одноразовых Email-адресов',
      role_based_addresses_count: 'Основанных на ролях Email-адресов',
      inactive_domain_addresses_count: 'Email-адресов с неактивным или несуществующим доменом',
    },
    action: 'Действие',
    action_copy: 'Скопировать',
    action_move: 'Переместить',
    action_delete: 'Удалить',
    to_group: 'В какую группу',
    to_blacklist: 'В какой черный список',
    additional_actions: 'Дополнительно',
    contacts_copied: 'Контактов скопировано',
    contacts_moved: 'Контактов перенесено',
    contacts_deleted: 'Контакты удалены',
    mSISDNDuplicates: 'Дубликатов номеров',
    emailDuplicates: 'Дубликатов Email',
    additionalDulicates: 'Дубликатов параметров',
    separator: 'Разделитель',
    file: 'Файл',
    autoImport: 'Автоматический импорт',
    checkDuplicates: 'Проверять контакты на уникальность',
    checkDuplicatesPolicy: 'Параметры проверки на уникальность',
    checkDuplicatesPolicies: {
      msisdn: 'Проверять по msisdn',
      email: 'Проверять по email',
      msisdn_email: 'Проверять по msisdn и email',
      all: 'Проверять по всем параметрам',
      file: 'Только файл',
      file_group: 'Файл и группа',
    },
    checkDisposable: 'Выявлять одноразовые адреса электронной почты',
    checkRoleBased: 'Выявлять основанные на ролях адреса электронной почты',
    checkExistence: 'Выявлять адреса электронной почты с несуществующим или неактивным доменом',
    importSuccess: 'Началась проверка контактов, по ее итогу будет сформирован отчет',
    fieldAssociation: 'Укажите соответствия загруженных полей',
    field: 'Загруженное поле',
    type: 'Тип',
    contactsCount: 'Количество контактов',
    types: {
      MSISDN: 'Телефон',
      EMAIL: 'E-mail',
      COMMENT: 'Комментарий',
      NAME: 'Имя',
      SURNAME: 'Фамилия',
      MIDDLENAME: 'Отчество',
      FIELD1: 'Доп. поле №1',
      FIELD2: 'Доп. поле №2',
      FIELD3: 'Доп. поле №3',
      FIELD4: 'Доп. поле №4',
      FIELD5: 'Доп. поле №5',
      FIELD6: 'Доп. поле №6',
    },
    dateFormat: 'Формат даты для доп. полей',
    dateFormats: {
      'DD-MM-YYYY': 'ДД-ММ-ГГГГ',
      'YYYY-MM-DD': 'ГГГГ-ММ-ДД',
      'MM-DD-YYYY': 'ММ-ДД-ГГГГ',
    }
  },

  distribution: {
    batchId: 'ID',
    createDatetime: 'Дата создания',
    startDatetime: 'Дата начала',
    endDatetime: 'Дата окончания',
    recipient: 'Получателей',
    start: 'Запустить',
    stop: 'Остановить',
    pause: 'Приостановить',
    resume: 'Возобновить',
    delete: 'Удалить',
    statuses: {
      GENERATED: 'Формируется',
      PAYMENT_WAITING: 'Ожидает оплаты',
      IN_PROGRESS: 'Запущена',
      ON_MODERATION: 'На модерации',
      DENIED: 'Запрещена',
      PAUSED: 'Приостановлена',
      STOPPED: 'Остановлена',
      ERROR: 'Ошибка',
      FINISHED: 'Завершена',
    },
    dialog: {
      start: 'Запустить рассылку?',
      stop: 'Остановить рассылку?',
      pause: 'Приостановить рассылку?',
      resume: 'Возобновить рассылку?',
    },
    messages: {
      emptyRecipients: 'Отправка невозможна, так как группа получателей была удалена',
      incorrectNumber: 'Некорректный номер телефона',
      incorrectEmail: 'Некорректный e-mail',
      templateSaved: 'Шаблон успешно сохранен',
      distributionSaved: 'Рассылка успешно создана',
    },
    step_template: 'Шаг 1: Шаблон',
    step_message: 'Шаг 2: Сообщение',
    step_recipients: 'Шаг {step}: Получатели',
    step_preview: 'Шаг {step}: Предпросмотр',
    template: 'Шаблон сообщения',
    resetText: 'Введенные ранее значения сохранены, если Вы хотите сбросить эти значения, нажмите ',
    resetButton: 'Сбросить',
    recipients: 'Получатели',
    saveTemplate: 'Сохранить как шаблон',
    create: 'Создать рассылку',
    recipientsLabel: 'Введите номера получателей через запятую, например: 79990123456, 79991234567',
    recipientsCount: 'Всего получателей - {contacts}, Введено вручную - {manual}, Выбрано групп - {groups}, Получателей в группах - {group_contacts}',
    totalRecipients: 'Количество контактов в рассылке',
    duplicatesCount: 'Дублирующихся контактов',
    distributionType: 'Тип рассылки',
    distributionEnd: 'Завершение рассылки',
    distributionTime: {
      title: 'Время рассылки',
      period: 'с {from} до {to}',
      notSpecified: 'Отправлять в любое время',
    },
    planned: 'Запланирована на ',
    immediate: 'Моментальная',
    distribution: 'Равномерно распределять отправку',
    allowedDays: 'Разрешенные дни для отправки',
    lifetime: 'Срок жизни сообщения (с)',
    blackList: 'Черный список',
    messageType: 'Тип сообщения',
    messageLength: 'Длина сообщения',
    multiChannel: {
      title: 'Цепочка мультиканальной отправки',
      enabled: 'Отправить через {interval} c использованием {channel}-шаблона {template}',
      disabled: 'Не отправлять по другому каналу',
    },
    originator: 'Отправитель',
    previewMessage: 'Пример отправляемого сообщения',
    withoutTemplate: 'Без шаблона',
    noLimit: 'Не ограничено',
    notSelected: 'Не выбран',
    notSpecified: 'Не указано',
    email: {
      recipientsLabel: 'Введите адреса получателей через запятую, например: test@example.com, user@example.com',
      subject: 'Тема письма',
      attachedFiles: 'Прикрепленные файлы',
      previewEmail: 'Пример отправляемого письма',
      preview: 'Предпросмотр',
    },
    push: {
      application: 'Приложение',
      platform: 'Платформа',
      filter: 'Фильтр',
    },
    call: {
      count: 'Максимум ',
      dtmf: 'по клавише',
      redirect: 'Переадресация на ',
      redirectBeep: 'после звукового сообщения',
      smsTemplate: 'С использованием шаблона ',
      sendSmsEnd: 'после завершения звонка',
      retry: 'Повторный звонок',
    },
    viber: {
      image: 'Изображение',
      button: 'Кнопка',
    }
  },

  push_filters: {
    string: {
      empty: 'Пустое',
      not_empty: 'Не пустое',
      contains: 'Содержит',
      not_contains: 'Не содержит',
      starts: 'Начинается с',
      ends: 'Заканчивается на',
      equal: 'Равно',
    },
    number: {
      empty: 'Пустое',
      not_empty: 'Не пустое',
      equal: 'Равно',
      not_equal: 'Не равно',
      greater: 'Больше',
      greater_equal: 'Больше или равно',
      lower: 'Меньше',
      lower_equal: 'Меньше или равно',
      between: 'Между',
      not_between: 'Не между',
    },
    date: {
      empty: 'Пустое',
      not_empty: 'Не пустое',
      equal: 'Равно',
      before: 'До',
      after: 'После',
      between: 'Между',
    },
    and: 'И',
    or: 'ИЛИ',
    attribute: 'Атрибут',
    relation: 'Условие',
    value: 'Значение',
    save: 'Сохранить фильтр',
    incorrect: 'Фильтр заполнен не полностью',
    add: 'Добавить фильтр',
  },

  lang: {
    ru: 'Русский',
    en: 'English',
  },

  variable: {
    number: 'Номер',
    name: 'Имя',
    surname: 'Фамилия',
    patronymic: 'Отчество',
    field_1: 'Поле 1',
    field_2: 'Поле 2',
    field_3: 'Поле 3',
    field_4: 'Поле 4',
    field_5: 'Поле 5',
    field_6: 'Поле 6',
    additional_fields: 'Дополнительные поля'
  },

  declensions: {
    days: 'дня/дней/дней',
    hours: 'час/часа/часов',
    minutes: 'минуту/минуты/минут',
    seconds: 'секунду/секунды/секунд',
    times: 'раз/раза/раз',
    symbols: 'символ/символа/символов',
  },

  week_days: {
    MON: 'Понедельник',
    TUE: 'Вторник',
    WED: 'Среда',
    THU: 'Четверг',
    FRI: 'Пятница',
    SAT: 'Суббота',
    SUN: 'Воскресенье',
  },

  values: {
    priority: {
      2: 'Low',
      4: 'Normal',
      6: 'High',
      8: 'Realtime',
    },
    active: {
      all: 'Все',
      active: 'Активный',
      inactive: 'Неактивный',
      yes: 'Да',
      no: 'Нет',
      1: 'Активный',
      0: 'Неактивный',
    },
    message_status: {
      Failed: 'Ошибка',
      Rejected: 'Отклонено',
      NotDelivered: 'Не доставлено',
      Delivered: 'Доставлено',
      Deferred: 'Отложено',
      Expired: 'Просрочено',
      Transmitted: 'Отправлено',
      NotAnswered: 'Не отвечено',
      Buffered: 'Отложено',

      Read: 'Прочитано',
      Error: 'Ошибка',
      Processed: 'Обработано',
      Finished: 'Завершено',
    },
    sender_status: {
      ACCEPTED: 'Разрешен',
      UNDER_CONSIDERATION: 'На рассмотрении',
      DENIED: 'Запрещен',
    },
    report_status: {
      NEW: 'Новый',
      IN_PROCESS: 'В процессе',
      FINISHED: 'Сформирован',
      FAILED: 'Ошибка',
    },
    template_status: {
      ForModeration: 'Ожидает модерации',
      OnModeration: 'На модерации',
    },
    deliveryType: {
      native: 'Native Push',
      web: 'Web Push',
      'web-and-native': 'Native Push и Web Push'
    },
    provider_connection_status: {
      1: 'Соединено',
      0: 'Не соединено',
    },
    report_types: {
      export: 'Отчеты экспорта',
      contacts_check: 'Отчеты проверки контактов',
    },
    specialUnsubscribeRuleList: {
      'do-not-unsubscribe': 'Не отписывать',
      all: 'Отписывать от всех email',
      template: 'Отписывать от шаблона',
      'message-type': 'Отписывать от типа сообщения',
    },
    unsubscribeRuleList: {
      'all': 'Отписывать от всех email',
      'template': 'Отписывать от шаблона',
      'message-type': 'Отписывать от типа сообщения',
    },
    subscribeRuleList: {
      'all': 'Подписывать на все email',
      'template': 'Подписывать на шаблон',
      'message-type': 'Подписывать на тип сообщения',
    },
    eventTypeList: {
      'opening': 'Открытие сообщения',
      'unsubscribing': 'Отписка',
      'subscribing': 'Подписка',
      'following_link': 'Переход по ссылке',
    },
    date: {
      min: '5 мин',
      min_15: '15 мин',
      hour: '1 час',
      today: 'Сегодня',
      yesterday: 'Вчера',
      week: 'Неделя',
      month: 'Месяц',
    },
    group_by: {
      hour: 'Часу',
      day: 'Дню',
      week: 'Неделе',
      month: 'Месяцу',
      partner: 'Клиенту',
      service_provider: 'Поставщику услуг',
      originator: 'Отправителю',
      template_id: 'ID шаблона',
      bulk_id: 'ID рассылки',
      broker_account_login: 'Аккаунту',
      application: 'Приложению',
      os: 'Операционной системе',
      message_category: 'Категории сообщений',
      message_type: 'Типу сообщений',
      push_type: 'Типу уведомления',
      country: 'Стране',
      operator: 'Оператору',
      mn_service_name: 'Сервису Mail Notify',
      mn_tmpl: 'Шаблону Mail Notify',
      routes: 'Каналу',
    },
    applications: {
      all: 'Все',
      last_created: 'Последнее созданное',
      by_priority: 'По приоритету',
      recipient: 'Получателю',
      last_subscription: 'С последней подпиской',
    },
    buttonActions: {
      link: "Перейти по ссылке",
      accept: "Действие принять",
      call: "Звонок",
      hide: "Скрыть",
      copy: "Копирование текста",
      custom: "Произвольное",
    },
    push_type: {
      native: 'Native Push',
      web: 'Web Push',
    }
  },
  sms_filter: {
    eq: 'Равно',
    noteq: 'Не равно',
    in: 'Содержит',
    notin: 'Не содержит',
  },

  delimiters: {
    comma: 'Запятая',
    semicolon: 'Точка с запятой',
    whitespace: 'Пробел',
    dot: 'Точка',
    colon: 'Двоеточие',
  },

  restrictions: {
    alpha: 'Только буквенные',
    numeric: 'Только числовые',
    allowed: 'Заданные',
  },

  dates: {
    create_date: 'Дата создания',
    date: 'Дата',
    date_from: 'Дата с',
    date_to: 'Дата по',
    defer_date: 'Дата отложенной отправки',
    delivery_date: 'Дата доставки',
    deliver_date_from: 'Дата доставки с',
    deliver_date_to: 'Дата доставки по',
    edit_date: 'Дата редактирования',
    end_date: 'Дата завершения',
    end_date_from: 'Дата доставки с',
    end_date_to: 'Дата доставки по',
    event_date: 'Дата операции',
    read_date: 'Дата прочтения',
    sent_date: 'Дата отправки',
    sent_date_from: 'Дата отправки с',
    sent_date_to: 'Дата отправки по',
    start_date: 'Дата начала',
    start_date_from: 'Дата создания с',
    start_date_to: 'Дата создания по',
  },

  statuses: {
    buffered: 'Отложено',
    deferred: 'Отложено',
    delivered: 'Доставлено',
    duration: 'Длительность',
    error: 'Ошибка',
    expired: 'Просрочено',
    failed: 'Ошибка',
    finished: 'Завершено',
    not_answered: 'Не отвечено',
    not_delivered: 'Не доставлено',
    processed: 'Обработано',
    read: 'Прочитано',
    rejected: 'Отклонено',
    statuses: 'Статусы',
    transmitted: 'Отправлено',
  },

  descriptions: {
    deferred: 'Сообщения будут отправлены позже',
    delivered: 'Сообщения были доставлены до абонента',
    expired: 'Сообщения были переданы оператору, их срок жизни истек в очереди оператора',
    failed: 'При попытке отправки сообщения возникла ошибка',
    not_delivered: 'Сообщения не были доставлены до абонента. Финальный статус',
    read: 'Сообщения были прочитаны',
    rejected: 'Сообщения были отклонены платформой',
    total: 'Общее число сообщений',
    transmitted: 'Сообщения были переданы оператору, но статус о доставке еще не получен',
    partner_price: 'Цена клиента',
    provider_price: 'Цена поставщика услуг',
  },

  telegram_otp_send: {
    title: 'Отправка Telegram OTP',
    recipient: 'Получатель',
    recipient_placeholder: '+7XXXXXXXXXX',
    originator: 'Отправитель',
    otp_code: 'OTP код',
    otp_code_placeholder: '4-8 цифр',
    callback_url: 'Callback URL',
    callback_url_placeholder: 'https://...',
    ttl: 'TTL (секунды)',
    otp_code_variable: 'Имя переменной OTP-кода',
    send: 'Отправить',
    sending: 'Отправка...',
    success: 'Сообщение успешно отправлено',
    field_required: 'Поле обязательно для заполнения',
    otp_code_invalid: 'OTP код должен содержать от 4 до 8 цифр',
  },

  helps: {
    template_activity_html: 'Даты начала и окончания действия шаблона.<ul>' +
      '<li>Если дата начала не заполнена, то шаблон начнет действовать сразу. Если заполнена, то шаблон начнет действовать с заданной даты.</li>' +
      '<li>Если дата окончания не заполнена, то срок действия шаблона не ограничен. Если заполнена, то в заданную дату шаблон перестанет действовать.</li></ul>',
    template_timeout_html: '<ul><li>Текст для справки по таймауту шаблона</li></ul>',
    tariff_zones_group_settings: 'Пожалуйста настройте группу тарифных зон',
    tariff_zones_create: 'Создать новую тарифную зону',
  },
};

export default messages;
